export const CHART_COLORS = {
    electricity: '#4472c4',
    electricityRgb: '68, 114, 196',
    gas: '#c00000',
    gasRgb: '192, 0, 0',
    postPeriod: '#ffc000',
    title: '#396598',
    regression: '#909399',
    axisLabel: '#6e7079',
};
